// import React from 'react';
// import { 
//   FaHeartbeat, 
//   FaHospital, 
//   FaAppleAlt, 
//   FaBookMedical, 
//   FaShieldAlt, 
//   FaUserCheck, 
//   FaStar, 
//   FaHandsHelping, 
//   FaEye, 
//   FaMedkit,
//   FaPhoneAlt,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaCheckCircle,
//   FaUsers,
//   FaHeart
// } from 'react-icons/fa';
// import { GiMedicinePills, GiStethoscope, GiHealthPotion } from 'react-icons/gi';

// const AboutUs = () => {
//   // Hospital brand colors
//   const hospitalColors = {
//     primary: '#0d9488', // Teal-600
//     secondary: '#059669', // Emerald-600
//     accent: '#10b981' // Emerald-500
//   };

//   // What We Offer data
//   const offerings = [
//     {
//       id: 1,
//       title: "Healthcare Products",
//       icon: <GiMedicinePills className="text-4xl" />,
//       color: "from-blue-500 to-cyan-500",
//       bgColor: "bg-blue-50 border-blue-100",
//       items: ["Medicines", "Health equipment", "Supplements", "Medical devices"]
//     },
//     {
//       id: 2,
//       title: "Hospital Information",
//       icon: <FaHospital className="text-4xl" />,
//       color: "from-emerald-500 to-green-500",
//       bgColor: "bg-emerald-50 border-emerald-100",
//       items: ["Single verified hospital", "Emergency availability", "Department details", "24/7 service"]
//     },
//     {
//       id: 3,
//       title: "Diet Plans",
//       icon: <FaAppleAlt className="text-4xl" />,
//       color: "from-purple-500 to-pink-500",
//       bgColor: "bg-purple-50 border-purple-100",
//       items: ["Disease-wise diet plans", "Expert-approved content", "Customized plans", "Nutrition guidance"]
//     },
//     {
//       id: 4,
//       title: "E-Books",
//       icon: <FaBookMedical className="text-4xl" />,
//       color: "from-indigo-500 to-blue-500",
//       bgColor: "bg-indigo-50 border-indigo-100",
//       items: ["Health awareness books", "Free & paid e-books", "Medical guides", "Wellness resources"]
//     }
//   ];

//   // Why Choose Us data
//   const whyChooseUs = [
//     {
//       id: 1,
//       title: "Trusted Healthcare Products",
//       description: "Verified and quality-checked medical products",
//       icon: <FaShieldAlt />,
//       color: "text-blue-500",
//       bg: "bg-blue-100"
//     },
//     {
//       id: 2,
//       title: "Verified Hospital Information",
//       description: "Single, reliable hospital partner with 24/7 emergency",
//       icon: <FaUserCheck />,
//       color: "text-emerald-500",
//       bg: "bg-emerald-100"
//     },
//     {
//       id: 3,
//       title: "Simple & User-Friendly Platform",
//       description: "Easy navigation and seamless user experience",
//       icon: <FaStar />,
//       color: "text-purple-500",
//       bg: "bg-purple-100"
//     },
//     {
//       id: 4,
//       title: "Secure Payment System",
//       description: "100% safe and encrypted transactions",
//       icon: <FaShieldAlt />,
//       color: "text-teal-500",
//       bg: "bg-teal-100"
//     },
//     {
//       id: 5,
//       title: "Health-Focused Content",
//       description: "Expert-reviewed medical information and guidance",
//       icon: <FaHeartbeat />,
//       color: "text-pink-500",
//       bg: "bg-pink-100"
//     },
//     {
//       id: 6,
//       title: "Expert Guidance",
//       description: "Professional advice for better health management",
//       icon: <FaHandsHelping />,
//       color: "text-orange-500",
//       bg: "bg-orange-100"
//     }
//   ];

//   // Our Values data
//   const values = [
//     { id: 1, title: "Trust", icon: <FaShieldAlt />, color: "from-blue-500 to-cyan-500", description: "Building reliable healthcare relationships" },
//     { id: 2, title: "Transparency", icon: <FaEye />, color: "from-emerald-500 to-green-500", description: "Clear and honest information sharing" },
//     { id: 3, title: "Quality", icon: <FaStar />, color: "from-purple-500 to-pink-500", description: "High standards in products and services" },
//     { id: 4, title: "User Care", icon: <FaHeart />, color: "from-red-500 to-pink-500", description: "Putting user health needs first" },
//     { id: 5, title: "Innovation", icon: <GiStethoscope />, color: "from-indigo-500 to-blue-500", description: "Modern healthcare solutions" },
//     { id: 6, title: "Community", icon: <FaUsers />, color: "from-orange-500 to-yellow-500", description: "Supporting health awareness" }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
//       {/* Page Title Section */}
//       <section className="relative py-20 px-4 md:px-8 overflow-hidden">
//         <div className="absolute inset-0 bg-gradient-to-r from-teal-600 to-emerald-600 opacity-90"></div>
//         <div 
//           className="absolute inset-0 bg-cover bg-center opacity-20"
//           style={{
//             backgroundImage: 'url("https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
//           }}
//         ></div>
        
//         <div className="relative max-w-6xl mx-auto text-center">
//           <div className="inline-flex items-center justify-center mb-6">
//             <div className="bg-white/20 p-4 rounded-full backdrop-blur-sm mr-4">
//               <GiStethoscope className="text-4xl text-white" />
//             </div>
//             <h1 className="text-5xl md:text-6xl font-bold text-white">About Us</h1>
//           </div>
          
//           <p className="text-2xl md:text-3xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
//             Your Trusted Healthcare Platform
//           </p>
          
//           <div className="w-32 h-1 bg-white mx-auto mb-8 rounded-full"></div>
          
//           <p className="text-xl text-white/80 max-w-2xl mx-auto">
//             Bringing healthcare products, hospital services, diet plans, and medical knowledge together for your well-being
//           </p>
          
//           <div className="mt-12 flex justify-center space-x-4">
//             <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
//               <FaMedkit className="text-3xl text-white" />
//             </div>
//             <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
//               <FaHospital className="text-3xl text-white" />
//             </div>
//             <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
//               <FaAppleAlt className="text-3xl text-white" />
//             </div>
//             <div className="bg-white/20 backdrop-blur-sm p-4 rounded-xl">
//               <FaBookMedical className="text-3xl text-white" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Who We Are Section */}
//       <section className="py-16 px-4 md:px-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="flex flex-col md:flex-row items-center gap-12">
//             <div className="md:w-1/2">
//               <div className="relative">
//                 <img 
//                   src="https://images.unsplash.com/photo-1559757175-0eb30cd8c063?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
//                   alt="Healthcare Team"
//                   className="rounded-2xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-300"
//                 />
//                 <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-teal-500 to-emerald-500 p-6 rounded-2xl shadow-xl">
//                   <FaHeartbeat className="text-4xl text-white" />
//                 </div>
//               </div>
//             </div>
            
//             <div className="md:w-1/2">
//               <div className="mb-8">
//                 <div className="inline-flex items-center mb-4">
//                   <div className="w-12 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mr-4"></div>
//                   <h2 className="text-3xl md:text-4xl font-bold" style={{ color: hospitalColors.primary }}>
//                     Who We Are
//                   </h2>
//                 </div>
                
//                 <div className="space-y-6">
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     We are a <span className="font-bold text-teal-600">dedicated healthcare platform</span> designed to provide trusted medical products, verified hospital information, disease-specific diet plans, and comprehensive health-related e-books all in one convenient place.
//                   </p>
                  
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     Our mission is to bridge the gap between healthcare providers and patients by creating a <span className="font-bold text-emerald-600">seamless digital ecosystem</span> that makes quality healthcare accessible, affordable, and reliable for everyone.
//                   </p>
                  
//                   <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-6 rounded-xl border-l-4 border-teal-500">
//                     <p className="text-gray-700 italic">
//                       "We believe in empowering individuals with the right healthcare resources and information to make informed decisions about their well-being."
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Our Mission Section */}
//       <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-gray-50 to-white">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: hospitalColors.primary }}>
//               Our Mission
//             </h2>
//             <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mx-auto mb-8 rounded-full"></div>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               Dedicated to transforming healthcare accessibility through innovation and compassion
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
//               <div className="bg-gradient-to-r from-blue-100 to-cyan-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
//                 <GiMedicinePills className="text-3xl text-blue-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">Quality Healthcare Products</h3>
//               <p className="text-gray-600">
//                 To provide authentic, quality-checked medical products including medicines, health equipment, and supplements directly to your doorstep.
//               </p>
//             </div>
            
//             <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
//               <div className="bg-gradient-to-r from-emerald-100 to-green-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
//                 <FaHospital className="text-3xl text-emerald-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">Accurate Medical Information</h3>
//               <p className="text-gray-600">
//                 To share reliable hospital and emergency information, ensuring users have access to verified healthcare facilities and services.
//               </p>
//             </div>
            
//             <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
//               <div className="bg-gradient-to-r from-purple-100 to-pink-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
//                 <FaAppleAlt className="text-3xl text-purple-600" />
//               </div>
//               <h3 className="text-xl font-bold text-gray-800 mb-4">Personalized Health Guidance</h3>
//               <p className="text-gray-600">
//                 To guide people with expert-approved diet plans for various diseases and provide comprehensive health education through e-books.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Our Vision Section */}
//       <section className="py-16 px-4 md:px-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-3xl p-8 md:p-12 shadow-xl">
//             <div className="flex flex-col md:flex-row items-center gap-12">
//               <div className="md:w-2/3">
//                 <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: hospitalColors.primary }}>
//                   Our Vision
//                 </h2>
                
//                 <div className="space-y-6">
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     Our vision is to create a <span className="font-bold text-teal-600">comprehensive digital healthcare platform</span> where users can effortlessly find medical products, authentic hospital details, personalized diet guidance, and valuable health knowledge—all easily accessible and completely safe.
//                   </p>
                  
//                   <p className="text-lg text-gray-700 leading-relaxed">
//                     We envision a future where healthcare is not just about treatment, but about <span className="font-bold text-emerald-600">prevention, education, and empowerment</span>. A platform that bridges the gap between medical professionals and patients, making quality healthcare a fundamental right, not a privilege.
//                   </p>
//                 </div>
                
//                 <div className="mt-8 flex items-center space-x-4">
//                   <div className="bg-white p-4 rounded-xl shadow">
//                     <GiHealthPotion className="text-3xl text-teal-600" />
//                   </div>
//                   <div>
//                     <h4 className="font-bold text-gray-800">Future Goals</h4>
//                     <p className="text-gray-600">Expanding services to telemedicine and AI-powered health monitoring</p>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="md:w-1/3">
//                 <div className="bg-white p-8 rounded-2xl shadow-lg text-center">
//                   <div className="bg-gradient-to-r from-teal-500 to-emerald-500 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
//                     <FaEye className="text-4xl text-white" />
//                   </div>
//                   <h3 className="text-2xl font-bold text-gray-800 mb-4">Looking Ahead</h3>
//                   <p className="text-gray-600">
//                     Building India's most trusted healthcare ecosystem by 2030
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* What We Offer Section */}
//       <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-white to-gray-50">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: hospitalColors.primary }}>
//               What We Offer
//             </h2>
//             <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mx-auto mb-8 rounded-full"></div>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               Comprehensive healthcare solutions tailored to your needs
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {offerings.map((offer) => (
//               <div key={offer.id} className={`${offer.bgColor} border-2 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2`}>
//                 <div className={`bg-gradient-to-r ${offer.color} w-16 h-16 rounded-2xl flex items-center justify-center mb-6`}>
//                   {offer.icon}
//                 </div>
                
//                 <h3 className="text-xl font-bold text-gray-800 mb-4">{offer.title}</h3>
                
//                 <ul className="space-y-3">
//                   {offer.items.map((item, index) => (
//                     <li key={index} className="flex items-center">
//                       <FaCheckCircle className="text-teal-500 mr-3" />
//                       <span className="text-gray-700">{item}</span>
//                     </li>
//                   ))}
//                 </ul>
                
//                 <div className="mt-6 pt-6 border-t border-gray-200">
//                   <button className={`text-white px-6 py-2 rounded-lg bg-gradient-to-r ${offer.color} hover:opacity-90 transition-opacity w-full`}>
//                     Explore More
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Why Choose Us Section */}
//       <section className="py-16 px-4 md:px-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: hospitalColors.primary }}>
//               Why Choose Us
//             </h2>
//             <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mx-auto mb-8 rounded-full"></div>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               We stand out with our commitment to quality, trust, and user satisfaction
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {whyChooseUs.map((item) => (
//               <div key={item.id} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100">
//                 <div className="flex items-start mb-4">
//                   <div className={`${item.bg} p-3 rounded-xl mr-4`}>
//                     <div className={item.color}>
//                       {item.icon}
//                     </div>
//                   </div>
//                   <div>
//                     <h3 className="text-lg font-bold text-gray-800">{item.title}</h3>
//                     <p className="text-gray-600 text-sm mt-1">{item.description}</p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Our Values Section */}
//       <section className="py-16 px-4 md:px-8 bg-gradient-to-r from-gray-50 to-teal-50">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: hospitalColors.primary }}>
//               Our Core Values
//             </h2>
//             <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mx-auto mb-8 rounded-full"></div>
//             <p className="text-gray-600 text-lg max-w-3xl mx-auto">
//               The principles that guide everything we do
//             </p>
//           </div>
          
//           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
//             {values.map((value) => (
//               <div key={value.id} className="text-center">
//                 <div className={`bg-gradient-to-r ${value.color} w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg`}>
//                   <div className="text-white text-3xl">
//                     {value.icon}
//                   </div>
//                 </div>
//                 <h3 className="font-bold text-gray-800 text-lg mb-2">{value.title}</h3>
//                 <p className="text-gray-600 text-sm">{value.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Contact Invitation Section */}
//       <section className="py-16 px-4 md:px-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="bg-gradient-to-r from-teal-600 to-emerald-600 rounded-3xl p-8 md:p-12 text-white text-center shadow-2xl">
//             <div className="max-w-2xl mx-auto">
//               <div className="bg-white/20 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
//                 <FaPhoneAlt className="text-3xl" />
//               </div>
              
//               <h2 className="text-3xl md:text-4xl font-bold mb-6">
//                 We're Here to Help You
//               </h2>
              
//               <p className="text-xl text-white/90 mb-8 leading-relaxed">
//                 If you have any questions about our services, need medical guidance, 
//                 or require support with healthcare products, our team is ready to assist you.
//               </p>
              
//               <div className="space-y-4 mb-8 max-w-md mx-auto">
//                 <div className="flex items-center justify-center space-x-4">
//                   <FaPhoneAlt className="text-xl" />
//                   <span className="text-lg">+91 1800-123-4567</span>
//                 </div>
//                 <div className="flex items-center justify-center space-x-4">
//                   <FaEnvelope className="text-xl" />
//                   <span className="text-lg">support@Anusayaplatform.com</span>
//                 </div>
//                 <div className="flex items-center justify-center space-x-4">
//                   <FaMapMarkerAlt className="text-xl" />
//                   <span className="text-lg">Healthcare Street, Medical City, India</span>
//                 </div>
//               </div>
              
//               <button className="bg-white text-teal-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl inline-flex items-center">
//                 <FaPhoneAlt className="mr-3" />
//                 Contact Us Now
//               </button>
              
//               <p className="text-white/70 mt-8 text-sm">
//                 Available 24/7 for emergency healthcare queries and support
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer Note */}
//       <footer className="py-8 px-4 md:px-8 bg-gray-900 text-white">
//         <div className="max-w-6xl mx-auto text-center">
//           <div className="flex items-center justify-center mb-4">
//             <GiStethoscope className="text-2xl mr-3 text-teal-400" />
//             <span className="text-xl font-bold">Anusaya Platform</span>
//           </div>
//           <p className="text-gray-400">
//             © 2024 Anusaya Healthcare Platform. Committed to your health and well-being.
//           </p>
//           <p className="text-gray-500 text-sm mt-2">
//             Trust • Quality • Care • Innovation
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default AboutUs;





// import React from 'react';
// import { 
//   FaHeartbeat, 
//   FaHospital, 
//   FaAppleAlt, 
//   FaBookMedical, 
//   FaShieldAlt, 
//   FaUserCheck, 
//   FaStar, 
//   FaHandsHelping, 
//   FaEye, 
//   FaMedkit,
//   FaPhoneAlt,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaCheckCircle,
//   FaUsers,
//   FaHeart
// } from 'react-icons/fa';
// import { GiMedicinePills, GiStethoscope, GiHealthPotion } from 'react-icons/gi';

// const AboutUs = () => {
//   // What We Offer data
//   const offerings = [
//     {
//       id: 1,
//       title: "Healthcare Products",
//       icon: <GiMedicinePills className="text-3xl" />,
//       color: "from-blue-500 to-cyan-500",
//       bgColor: "bg-blue-50 border-blue-100",
//       items: ["Medicines", "Health equipment", "Supplements", "Medical devices"]
//     },
//     {
//       id: 2,
//       title: "Hospital Information",
//       icon: <FaHospital className="text-3xl" />,
//       color: "from-emerald-500 to-green-500",
//       bgColor: "bg-emerald-50 border-emerald-100",
//       items: ["Verified hospital", "Emergency availability", "Department details", "24/7 service"]
//     },
//     {
//       id: 3,
//       title: "Diet Plans",
//       icon: <FaAppleAlt className="text-3xl" />,
//       color: "from-purple-500 to-pink-500",
//       bgColor: "bg-purple-50 border-purple-100",
//       items: ["Disease-wise diet plans", "Expert-approved content", "Customized plans", "Nutrition guidance"]
//     },
//     {
//       id: 4,
//       title: "E-Books",
//       icon: <FaBookMedical className="text-3xl" />,
//       color: "from-indigo-500 to-blue-500",
//       bgColor: "bg-indigo-50 border-indigo-100",
//       items: ["Health awareness books", "Free & paid e-books", "Medical guides", "Wellness resources"]
//     }
//   ];

//   // Why Choose Us data
//   const whyChooseUs = [
//     {
//       id: 1,
//       title: "Trusted Healthcare Products",
//       description: "Verified and quality-checked medical products",
//       icon: <FaShieldAlt />,
//       color: "text-blue-500",
//       bg: "bg-blue-100"
//     },
//     {
//       id: 2,
//       title: "Verified Hospital Information",
//       description: "Single, reliable hospital partner with 24/7 emergency",
//       icon: <FaUserCheck />,
//       color: "text-emerald-500",
//       bg: "bg-emerald-100"
//     },
//     {
//       id: 3,
//       title: "Simple & User-Friendly Platform",
//       description: "Easy navigation and seamless user experience",
//       icon: <FaStar />,
//       color: "text-purple-500",
//       bg: "bg-purple-100"
//     },
//     {
//       id: 4,
//       title: "Secure Payment System",
//       description: "100% safe and encrypted transactions",
//       icon: <FaShieldAlt />,
//       color: "text-teal-500",
//       bg: "bg-teal-100"
//     },
//     {
//       id: 5,
//       title: "Health-Focused Content",
//       description: "Expert-reviewed medical information",
//       icon: <FaHeartbeat />,
//       color: "text-pink-500",
//       bg: "bg-pink-100"
//     },
//     {
//       id: 6,
//       title: "Expert Guidance",
//       description: "Professional advice for health management",
//       icon: <FaHandsHelping />,
//       color: "text-orange-500",
//       bg: "bg-orange-100"
//     }
//   ];

//   // Our Values data
//   const values = [
//     { id: 1, title: "Trust", icon: <FaShieldAlt />, color: "from-blue-500 to-cyan-500", description: "Reliable healthcare relationships" },
//     { id: 2, title: "Transparency", icon: <FaEye />, color: "from-emerald-500 to-green-500", description: "Honest information sharing" },
//     { id: 3, title: "Quality", icon: <FaStar />, color: "from-purple-500 to-pink-500", description: "High standards in services" },
//     { id: 4, title: "User Care", icon: <FaHeart />, color: "from-red-500 to-pink-500", description: "User health needs first" },
//     { id: 5, title: "Innovation", icon: <GiStethoscope />, color: "from-indigo-500 to-blue-500", description: "Modern healthcare solutions" },
//     { id: 6, title: "Community", icon: <FaUsers />, color: "from-orange-500 to-yellow-500", description: "Supporting health awareness" }
//   ];

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
//       {/* Main Content with Responsive Padding */}
//       <div className="pt-5 lg:pt-8 px-3 sm:px-4 md:px-6 lg:px-8 pb-8">
//         <div className="max-w-7xl mx-auto">
//           {/* Hero Banner */}
//           <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden mb-6 lg:mb-8">
//             <div className="absolute inset-0 bg-gradient-to-r from-teal-700 to-emerald-700 opacity-90"></div>
//             <div 
//               className="absolute inset-0 bg-cover bg-center opacity-20"
//               style={{
//                 backgroundImage: 'url("https://images.unsplash.com/photo-1579684385127-1ef15d508118?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")'
//               }}
//             ></div>
            
//             <div className="relative p-6 sm:p-8 lg:p-12">
//               <div className="max-w-3xl">
//                 <div className="inline-flex items-center mb-4">
//                   <div className="bg-white/20 p-3 rounded-full backdrop-blur-sm mr-4">
//                     <GiStethoscope className="text-2xl sm:text-3xl text-white" />
//                   </div>
//                   <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">About Us</h1>
//                 </div>
                
//                 <p className="text-lg sm:text-xl lg:text-2xl text-white/90 mb-6 leading-relaxed">
//                   Your Trusted Healthcare Platform
//                 </p>
                
//                 <p className="text-white/80 text-sm sm:text-base mb-6">
//                   Bringing healthcare products, hospital services, diet plans, and medical knowledge together for your well-being
//                 </p>
                
//                 <div className="flex flex-wrap gap-3">
//                   <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
//                     <FaMedkit className="text-xl text-white" />
//                   </div>
//                   <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
//                     <FaHospital className="text-xl text-white" />
//                   </div>
//                   <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
//                     <FaAppleAlt className="text-xl text-white" />
//                   </div>
//                   <div className="bg-white/20 backdrop-blur-sm p-3 rounded-lg">
//                     <FaBookMedical className="text-xl text-white" />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Who We Are Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
//               <div className="p-4 sm:p-6 lg:p-8">
//                 <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-8">
//                   {/* Image */}
//                   <div className="mb-6 lg:mb-0 lg:w-1/3">
//                     <div className="relative">
//                       <img 
//                         src="https://images.unsplash.com/photo-1559757175-0eb30cd8c063?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
//                         alt="Healthcare Team"
//                         className="w-full rounded-xl shadow-lg"
//                       />
//                       <div className="absolute -bottom-3 -right-3 bg-gradient-to-r from-teal-500 to-emerald-500 p-4 rounded-lg shadow-lg">
//                         <FaHeartbeat className="text-2xl text-white" />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Content */}
//                   <div className="lg:w-2/3">
//                     <div className="mb-4">
//                       <div className="flex items-center mb-3">
//                         <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mr-3"></div>
//                         <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Who We Are</h2>
//                       </div>
                      
//                       <div className="space-y-4">
//                         <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                           We are a <span className="font-bold text-teal-600">dedicated healthcare platform</span> designed to provide trusted medical products, verified hospital information, disease-specific diet plans, and comprehensive health-related e-books all in one convenient place.
//                         </p>
                        
//                         <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                           Our mission is to bridge the gap between healthcare providers and patients by creating a <span className="font-bold text-emerald-600">seamless digital ecosystem</span> that makes quality healthcare accessible, affordable, and reliable for everyone.
//                         </p>
                        
//                         <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-4 rounded-lg border-l-4 border-teal-500">
//                           <p className="text-gray-700 italic text-sm sm:text-base">
//                             "We believe in empowering individuals with the right healthcare resources and information to make informed decisions about their well-being."
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Our Mission Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="flex items-center justify-between mb-4 lg:mb-6">
//               <h2 className="text-lg lg:text-xl font-bold text-gray-800">Our Mission</h2>
//               <button className="text-teal-600 hover:text-teal-700 text-sm font-medium">
//                 Learn More →
//               </button>
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
//               <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200">
//                 <div className="bg-gradient-to-r from-blue-100 to-cyan-100 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
//                   <GiMedicinePills className="text-2xl text-blue-600" />
//                 </div>
//                 <h3 className="font-bold text-gray-800 mb-3 text-sm sm:text-base">Quality Healthcare Products</h3>
//                 <p className="text-gray-600 text-xs sm:text-sm">
//                   To provide authentic, quality-checked medical products including medicines, health equipment, and supplements directly to your doorstep.
//                 </p>
//               </div>
              
//               <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200">
//                 <div className="bg-gradient-to-r from-emerald-100 to-green-100 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
//                   <FaHospital className="text-2xl text-emerald-600" />
//                 </div>
//                 <h3 className="font-bold text-gray-800 mb-3 text-sm sm:text-base">Accurate Medical Information</h3>
//                 <p className="text-gray-600 text-xs sm:text-sm">
//                   To share reliable hospital and emergency information, ensuring users have access to verified healthcare facilities and services.
//                 </p>
//               </div>
              
//               <div className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200">
//                 <div className="bg-gradient-to-r from-purple-100 to-pink-100 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
//                   <FaAppleAlt className="text-2xl text-purple-600" />
//                 </div>
//                 <h3 className="font-bold text-gray-800 mb-3 text-sm sm:text-base">Personalized Health Guidance</h3>
//                 <p className="text-gray-600 text-xs sm:text-sm">
//                   To guide people with expert-approved diet plans for various diseases and provide comprehensive health education through e-books.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Our Vision Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8">
//               <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-8">
//                 <div className="lg:w-2/3">
//                   <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Our Vision</h2>
                  
//                   <div className="space-y-4 mb-6">
//                     <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                       Our vision is to create a <span className="font-bold text-teal-600">comprehensive digital healthcare platform</span> where users can effortlessly find medical products, authentic hospital details, personalized diet guidance, and valuable health knowledge—all easily accessible and completely safe.
//                     </p>
                    
//                     <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                       We envision a future where healthcare is not just about treatment, but about <span className="font-bold text-emerald-600">prevention, education, and empowerment</span>. A platform that bridges the gap between medical professionals and patients.
//                     </p>
//                   </div>
                  
//                   <div className="bg-white p-4 rounded-lg shadow-sm">
//                     <div className="flex items-center">
//                       <div className="bg-teal-100 p-3 rounded-lg mr-4">
//                         <GiHealthPotion className="text-2xl text-teal-600" />
//                       </div>
//                       <div>
//                         <h4 className="font-bold text-gray-800 text-sm sm:text-base">Future Goals</h4>
//                         <p className="text-gray-600 text-xs sm:text-sm">Expanding services to telemedicine and AI-powered health monitoring</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
                
//                 <div className="lg:w-1/3 mt-6 lg:mt-0">
//                   <div className="bg-white rounded-xl p-6 shadow-lg text-center">
//                     <div className="bg-gradient-to-r from-teal-500 to-emerald-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
//                       <FaEye className="text-3xl text-white" />
//                     </div>
//                     <h3 className="font-bold text-gray-800 mb-3 text-lg">Looking Ahead</h3>
//                     <p className="text-gray-600 text-sm">
//                       Building India's most trusted healthcare ecosystem by 2030
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* What We Offer Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="flex items-center justify-between mb-4 lg:mb-6">
//               <h2 className="text-lg lg:text-xl font-bold text-gray-800">What We Offer</h2>
//               <button className="text-teal-600 hover:text-teal-700 text-sm font-medium">
//                 View All →
//               </button>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
//               {offerings.map((offer) => (
//                 <div key={offer.id} className={`${offer.bgColor} border rounded-xl sm:rounded-2xl p-4 sm:p-6 hover:shadow-md transition-all duration-300`}>
//                   <div className={`bg-gradient-to-r ${offer.color} w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4`}>
//                     {offer.icon}
//                   </div>
                  
//                   <h3 className="font-bold text-gray-800 mb-3 text-sm sm:text-base">{offer.title}</h3>
                  
//                   <ul className="space-y-2 mb-4">
//                     {offer.items.map((item, index) => (
//                       <li key={index} className="flex items-center">
//                         <FaCheckCircle className="text-teal-500 mr-2 text-sm" />
//                         <span className="text-gray-700 text-xs sm:text-sm">{item}</span>
//                       </li>
//                     ))}
//                   </ul>
                  
//                   <div className="pt-4 border-t border-gray-200">
//                     <button className={`text-white px-4 py-2 rounded-lg bg-gradient-to-r ${offer.color} hover:opacity-90 transition-opacity text-xs sm:text-sm w-full`}>
//                       Explore More
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Why Choose Us Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="flex items-center justify-between mb-4 lg:mb-6">
//               <h2 className="text-lg lg:text-xl font-bold text-gray-800">Why Choose Us</h2>
//               <button className="text-teal-600 hover:text-teal-700 text-sm font-medium">
//                 See Benefits →
//               </button>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
//               {whyChooseUs.map((item) => (
//                 <div key={item.id} className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200">
//                   <div className="flex items-start mb-3">
//                     <div className={`${item.bg} p-2 sm:p-3 rounded-lg mr-3 sm:mr-4`}>
//                       <div className={`${item.color} text-sm sm:text-base`}>
//                         {item.icon}
//                       </div>
//                     </div>
//                     <div>
//                       <h3 className="font-bold text-gray-800 text-sm sm:text-base mb-1">{item.title}</h3>
//                       <p className="text-gray-600 text-xs sm:text-sm">{item.description}</p>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Our Values Section */}
//           <div className="mb-8 lg:mb-12">
//             <div className="flex items-center justify-between mb-4 lg:mb-6">
//               <h2 className="text-lg lg:text-xl font-bold text-gray-800">Our Core Values</h2>
//               <button className="text-teal-600 hover:text-teal-700 text-sm font-medium">
//                 View Details →
//               </button>
//             </div>

//             <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
//               {values.map((value) => (
//                 <div key={value.id} className="text-center">
//                   <div className={`bg-gradient-to-r ${value.color} w-12 h-12 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-sm`}>
//                     <div className="text-white text-lg sm:text-xl">
//                       {value.icon}
//                     </div>
//                   </div>
//                   <h3 className="font-bold text-gray-800 text-xs sm:text-sm mb-1">{value.title}</h3>
//                   <p className="text-gray-600 text-xs">{value.description}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Contact Section */}
//           <div className="bg-gradient-to-r from-teal-600 to-emerald-600 rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-8 text-white shadow-lg">
//             <div className="text-center mb-6">
//               <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2">We're Here to Help You</h2>
//               <p className="text-white/90 text-sm sm:text-base">Contact us for healthcare support and guidance</p>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
//               {/* Contact Info */}
//               <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6">
//                 <div className="text-center mb-6">
//                   <div className="bg-white/20 w-12 h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center mx-auto mb-4">
//                     <FaPhoneAlt className="text-xl sm:text-2xl" />
//                   </div>
//                   <h3 className="text-lg sm:text-xl font-bold mb-2">Contact Details</h3>
//                   <p className="text-white/80 text-sm sm:text-base mb-4">Available for healthcare queries and support</p>
//                 </div>
                
//                 <div className="space-y-3 mb-6">
//                   <div className="flex items-center justify-between bg-white/10 p-3 rounded-lg">
//                     <span className="font-medium text-sm sm:text-base">Phone</span>
//                     <span className="font-bold text-sm sm:text-base">+91 1800-123-4567</span>
//                   </div>
//                   <div className="flex items-center justify-between bg-white/10 p-3 rounded-lg">
//                     <span className="font-medium text-sm sm:text-base">Email</span>
//                     <span className="font-bold text-sm sm:text-base">support@Anusaya.com</span>
//                   </div>
//                   <div className="flex items-center justify-between bg-white/10 p-3 rounded-lg">
//                     <span className="font-medium text-sm sm:text-base">Location</span>
//                     <span className="font-bold text-sm sm:text-base">Healthcare Street, India</span>
//                   </div>
//                 </div>
                
//                 <button className="w-full bg-white text-teal-600 px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors text-sm sm:text-base">
//                   <FaPhoneAlt className="inline mr-2" />
//                   Contact Us Now
//                 </button>
//               </div>

//               {/* Quick Message */}
//               <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 text-gray-800">
//                 <h3 className="text-lg sm:text-xl font-bold mb-4 text-center">Quick Message</h3>
//                 <div className="space-y-4">
//                   <div className="bg-teal-50 p-4 rounded-lg border border-teal-100">
//                     <p className="text-gray-700 text-sm sm:text-base">
//                       If you have any questions about our services, need medical guidance, or require support with healthcare products, our team is ready to assist you.
//                     </p>
//                   </div>
                  
//                   <div className="bg-gradient-to-r from-gray-50 to-teal-50 rounded-lg p-4">
//                     <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">Availability</h4>
//                     <div className="flex items-center text-teal-600">
//                       <div className="bg-teal-100 p-2 rounded-lg mr-3">
//                         <FaCheckCircle className="text-teal-600" />
//                       </div>
//                       <span className="font-medium text-sm sm:text-base">24/7 Emergency Healthcare Support</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Footer Note */}
//           {/* <div className="mt-6 lg:mt-8 bg-gray-900 rounded-xl sm:rounded-2xl overflow-hidden">
//             <div className="p-4 sm:p-6 text-center">
//               <div className="flex items-center justify-center mb-3">
//                 <GiStethoscope className="text-xl mr-3 text-teal-400" />
//                 <span className="text-lg font-bold text-white">Anusaya Platform</span>
//               </div>
//               <p className="text-gray-400 text-xs sm:text-sm">
//                 © 2024 Anusaya Healthcare Platform. Committed to your health and well-being.
//               </p>
//               <p className="text-gray-500 text-xs mt-2">
//                 Trust • Quality • Care • Innovation
//               </p>
//             </div>
//           </div> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;





import React from 'react';
import { 
  FaHeartbeat, 
  FaHospital, 
  FaAppleAlt, 
  FaBookMedical, 
  FaShieldAlt, 
  FaUserCheck, 
  FaStar, 
  FaHandsHelping, 
  FaEye, 
  FaMedkit,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaUsers,
  FaHeart,
  FaArrowRight,
  FaRocket,
  FaBolt,
  FaAward,
  FaChartLine,
  FaGlobe,
  FaHandHoldingHeart,
  FaLightbulb,
  FaBalanceScale,
  FaLeaf,
  FaTrophy
} from 'react-icons/fa';
import { 
  GiMedicinePills, 
  GiStethoscope, 
  GiHealthPotion,
  GiDoctorFace,
  GiMedicalPackAlt,
  GiHeartOrgan,
  GiBrain,
  GiGrowth,
  GiTargetPrize
} from 'react-icons/gi';
import { motion } from 'framer-motion';
import { IoMdFitness } from 'react-icons/io';

const AboutUs = () => {
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.4, ease: "easeOut" }
    }
  };

  // What We Offer data
  const offerings = [
    {
      id: 1,
      title: "Healthcare Products",
      description: "Authentic medical supplies delivered safely",
      icon: <GiMedicinePills className="text-4xl" />,
      color: "from-blue-500 to-cyan-500",
      gradient: "bg-gradient-to-r from-blue-500 to-cyan-500",
      features: ["Verified medicines", "Health equipment", "Supplements", "Medical devices"],
      count: "500+ Products"
    },
    {
      id: 2,
      title: "Hospital Services",
      description: "Verified healthcare facilities information",
      icon: <FaHospital className="text-4xl" />,
      color: "from-emerald-500 to-green-500",
      gradient: "bg-gradient-to-r from-emerald-500 to-green-500",
      features: ["24/7 emergency", "Specialist doctors", "Advanced facilities", "Online booking"],
      count: "45+ Specialists"
    },
    {
      id: 3,
      title: "Diet & Nutrition",
      description: "Personalized health meal plans",
      icon: <FaAppleAlt className="text-4xl" />,
      color: "from-purple-500 to-pink-500",
      gradient: "bg-gradient-to-r from-purple-500 to-pink-500",
      features: ["Disease-specific plans", "Expert-approved", "Customized meals", "Progress tracking"],
      count: "50+ Diet Plans"
    },
    {
      id: 4,
      title: "Health Education",
      description: "Comprehensive medical knowledge",
      icon: <FaBookMedical className="text-4xl" />,
      color: "from-indigo-500 to-blue-500",
      gradient: "bg-gradient-to-r from-indigo-500 to-blue-500",
      features: ["Free e-books", "Medical guides", "Health tips", "Expert articles"],
      count: "100+ Resources"
    }
  ];

  // Why Choose Us data
  const whyChooseUs = [
    {
      id: 1,
      title: "Trusted Healthcare Products",
      description: "Verified and quality-checked medical products from certified suppliers",
      icon: <FaShieldAlt />,
      color: "text-blue-500",
      gradient: "from-blue-500 to-cyan-500",
      stat: "100% Verified"
    },
    {
      id: 2,
      title: "Verified Hospital Network",
      description: "Single, reliable hospital partner with 24/7 emergency services",
      icon: <FaUserCheck />,
      color: "text-emerald-500",
      gradient: "from-emerald-500 to-green-500",
      stat: "24/7 Support"
    },
    {
      id: 3,
      title: "User-Friendly Platform",
      description: "Intuitive interface designed for seamless healthcare management",
      icon: <FaStar />,
      color: "text-purple-500",
      gradient: "from-purple-500 to-pink-500",
      stat: "99% Satisfaction"
    },
    {
      id: 4,
      title: "Secure Transactions",
      description: "100% safe and encrypted payment system for peace of mind",
      icon: <FaShieldAlt />,
      color: "text-teal-500",
      gradient: "from-teal-500 to-cyan-500",
      stat: "Zero Fraud"
    },
    {
      id: 5,
      title: "Expert Content",
      description: "Medical information reviewed by healthcare professionals",
      icon: <GiDoctorFace />,
      color: "text-pink-500",
      gradient: "from-pink-500 to-rose-500",
      stat: "Expert Reviewed"
    },
    {
      id: 6,
      title: "Personalized Guidance",
      description: "Customized health plans based on individual needs",
      icon: <FaHandsHelping />,
      color: "text-orange-500",
      gradient: "from-orange-500 to-yellow-500",
      stat: "Personalized"
    }
  ];

  // Our Values data
  const values = [
    { 
      id: 1, 
      title: "Integrity", 
      icon: <FaShieldAlt />, 
      color: "from-blue-500 to-cyan-500",
      description: "Honest and transparent healthcare services"
    },
    { 
      id: 2, 
      title: "Excellence", 
      icon: <FaAward />, 
      color: "from-emerald-500 to-green-500",
      description: "Highest standards in medical care"
    },
    { 
      id: 3, 
      title: "Innovation", 
      icon: <FaLightbulb />, 
      color: "from-purple-500 to-pink-500",
      description: "Modern healthcare solutions"
    },
    { 
      id: 4, 
      title: "Compassion", 
      icon: <FaHeart />, 
      color: "from-red-500 to-pink-500",
      description: "Empathetic patient care"
    },
    { 
      id: 5, 
      title: "Accessibility", 
      icon: <FaGlobe />, 
      color: "from-indigo-500 to-blue-500",
      description: "Healthcare for everyone"
    },
    { 
      id: 6, 
      title: "Sustainability", 
      icon: <FaLeaf />, 
      color: "from-orange-500 to-yellow-500",
      description: "Environmentally responsible practices"
    }
  ];

  // Milestones data
  const milestones = [
    { id: 1, value: "10K+", label: "Happy Patients", icon: <FaUsers />, color: "text-blue-500" },
    { id: 2, value: "500+", label: "Healthcare Products", icon: <GiMedicalPackAlt />, color: "text-emerald-500" },
    { id: 3, value: "45+", label: "Medical Experts", icon: <GiDoctorFace />, color: "text-purple-500" },
    { id: 4, value: "99%", label: "Satisfaction Rate", icon: <FaChartLine />, color: "text-pink-500" }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="relative min-h-[60vh] lg:min-h-[70vh] overflow-hidden bg-gradient-to-r from-teal-600 via-emerald-500 to-teal-400"
      >
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(15)].map((_, i) => (
            <motion.div
              key={i}
              className="absolute w-4 h-4 bg-white/20 rounded-full"
              initial={{ y: -100, x: Math.random() * 100 }}
              animate={{ 
                y: 800,
                x: Math.random() * 100 - 50,
              }}
              transition={{
                duration: Math.random() * 10 + 10,
                repeat: Infinity,
                delay: Math.random() * 5
              }}
              style={{
                left: `${Math.random() * 100}%`
              }}
            />
          ))}
        </div>

        <div className="relative h-full flex items-center py-12 lg:py-20 px-4 lg:px-8">
          <div className="max-w-7xl mx-auto w-full">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center lg:text-left"
            >
              <div className="inline-flex items-center mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
                <div className="mr-3">
                  <GiStethoscope className="text-white text-xl" />
                </div>
                <span className="font-semibold text-white">Healthcare Revolution</span>
              </div>

              <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Your Health, <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">Our Mission</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-white/90 mb-8 max-w-3xl mx-auto lg:mx-0">
                Empowering healthier lives through integrated healthcare solutions and trusted medical guidance.
              </p>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-gradient-to-r from-white to-gray-100 text-teal-600 px-8 py-4 rounded-xl font-bold hover:shadow-2xl transition-all shadow-lg"
              >
                <span className="flex items-center">
                  Explore Our Services 
                  <FaArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" />
                </span>
              </motion.button>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Main Content */}
      <div className="py-12 lg:py-16 px-4 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Mission & Vision */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
            {/* Mission */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              className="bg-white rounded-2xl lg:rounded-3xl shadow-xl p-6 lg:p-8 border border-gray-200"
            >
              <div className="flex items-center mb-6">
                <div className="bg-gradient-to-r from-teal-500 to-emerald-500 w-14 h-14 rounded-2xl flex items-center justify-center mr-4">
                  <GiTargetPrize className="text-white text-2xl" />
                </div>
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold text-gray-800">Our Mission</h2>
                  <p className="text-gray-600">What drives us forward</p>
                </div>
              </div>

              <p className="text-gray-700 text-lg mb-6 leading-relaxed">
                To create a <span className="font-bold text-teal-600">seamless healthcare ecosystem</span> that combines trusted medical products, verified hospital services, personalized nutrition guidance, and comprehensive health education—all accessible through a single, user-friendly platform.
              </p>

              <div className="bg-gradient-to-r from-teal-50 to-emerald-50 p-6 rounded-xl border-l-4 border-teal-500">
                <p className="text-gray-700 italic">
                  "We believe in making quality healthcare accessible, affordable, and understandable for everyone, regardless of their background or location."
                </p>
              </div>
            </motion.div>

            {/* Vision */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={fadeInUp}
              transition={{ delay: 0.1 }}
              className="bg-gradient-to-r from-teal-600 to-emerald-500 rounded-2xl lg:rounded-3xl p-6 lg:p-8 text-white"
            >
              <div className="flex items-center mb-6">
                <div className="bg-white/20 w-14 h-14 rounded-2xl flex items-center justify-center mr-4">
                  <FaEye className="text-white text-2xl" />
                </div>
                <div>
                  <h2 className="text-2xl lg:text-3xl font-bold">Our Vision</h2>
                  <p className="text-white/80">Where we're headed</p>
                </div>
              </div>

              <p className="text-white/90 text-lg mb-6 leading-relaxed">
                To become India's <span className="font-bold">most trusted digital healthcare platform</span> by 2030, revolutionizing how people access and experience healthcare through innovation, empathy, and excellence.
              </p>

              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                <div className="flex items-center">
                  <FaRocket className="text-2xl mr-3" />
                  <div>
                    <h4 className="font-bold text-lg mb-1">Future Goals</h4>
                    <p className="text-white/80">Telemedicine, AI health monitoring, and nationwide expansion</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Milestones */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="mb-16"
          >
            <div className="text-center mb-8 lg:mb-12">
              <h2 className="text-2xl lg:text-4xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
                Our Impact in Numbers
              </h2>
              <div className="w-20 lg:w-24 h-1 bg-gradient-to-r from-blue-500 to-teal-500 mx-auto mb-4 rounded-full"></div>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Transforming healthcare through measurable achievements
              </p>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
              {milestones.map((milestone) => (
                <motion.div
                  key={milestone.id}
                  variants={scaleIn}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  <div className={`text-3xl lg:text-4xl mb-3 ${milestone.color}`}>
                    {milestone.icon}
                  </div>
                  <motion.div 
                    className="text-3xl lg:text-4xl font-bold text-gray-800 mb-2"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: milestone.id * 0.1, type: "spring" }}
                  >
                    {milestone.value}
                  </motion.div>
                  <div className="text-gray-600 font-medium">{milestone.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* What We Offer */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="mb-16"
          >
            <div className="text-center mb-8 lg:mb-12">
              <h2 className="text-2xl lg:text-4xl font-bold mb-4 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Our Services
              </h2>
              <div className="w-20 lg:w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto mb-4 rounded-full"></div>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Comprehensive healthcare solutions for all your needs
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
              {offerings.map((offer) => (
                <motion.div
                  key={offer.id}
                  whileHover={{ y: -8 }}
                  className="bg-white rounded-2xl lg:rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden group"
                >
                  <div className="p-6 lg:p-8">
                    <div className="flex flex-col lg:flex-row lg:items-start gap-6">
                      <div className={`${offer.gradient} w-16 h-16 lg:w-20 lg:h-20 rounded-2xl flex items-center justify-center flex-shrink-0`}>
                        <div className="text-white text-2xl lg:text-3xl">
                          {offer.icon}
                        </div>
                      </div>

                      <div className="flex-1">
                        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between mb-4">
                          <div>
                            <h3 className="font-bold text-gray-800 text-xl lg:text-2xl mb-2 group-hover:text-teal-600 transition-colors">
                              {offer.title}
                            </h3>
                            <p className="text-gray-600 mb-4">{offer.description}</p>
                          </div>
                          <div className="lg:text-right">
                            <div className="inline-flex items-center bg-gray-100 px-3 py-1 rounded-full text-sm font-medium mb-2">
                              <FaBolt className="mr-2" /> {offer.count}
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3 mb-6">
                          {offer.features.map((feature, index) => (
                            <div key={index} className="flex items-center">
                              <FaCheckCircle className="text-green-500 mr-2 flex-shrink-0" />
                              <span className="text-gray-700 text-sm">{feature}</span>
                            </div>
                          ))}
                        </div>

                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className={`w-full bg-gradient-to-r ${offer.color} text-white px-6 py-3 rounded-xl hover:shadow-lg transition-all font-bold flex items-center justify-center group`}
                        >
                          <span>Explore {offer.title}</span>
                          <FaArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" />
                        </motion.button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Why Choose Us */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="mb-16"
          >
            <div className="text-center mb-8 lg:mb-12">
              <h2 className="text-2xl lg:text-4xl font-bold mb-4 bg-gradient-to-r from-orange-600 to-yellow-600 bg-clip-text text-transparent">
                Why Choose Anusaya
              </h2>
              <div className="w-20 lg:w-24 h-1 bg-gradient-to-r from-orange-500 to-yellow-500 mx-auto mb-4 rounded-full"></div>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Discover what makes us the preferred healthcare platform
              </p>
            </div>

            <motion.div
              variants={staggerContainer}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              {whyChooseUs.map((item) => (
                <motion.div
                  key={item.id}
                  variants={scaleIn}
                  whileHover={{ 
                    y: -5,
                    transition: { duration: 0.3 }
                  }}
                  className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex items-center mb-4">
                    <div className={`bg-gradient-to-r ${item.gradient} w-12 h-12 rounded-xl flex items-center justify-center mr-4`}>
                      <div className="text-white text-xl">
                        {item.icon}
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-800 text-lg">{item.title}</h3>
                      <div className="text-sm text-gray-500 font-medium">{item.stat}</div>
                    </div>
                  </div>

                  <p className="text-gray-600 mb-4">{item.description}</p>

                  <div className={`h-1 bg-gradient-to-r ${item.gradient} rounded-full`}></div>
                </motion.div>
              ))}
            </motion.div>
          </motion.section>

          {/* Our Values */}
          <motion.section
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="mb-16"
          >
            <div className="text-center mb-8 lg:mb-12">
              <h2 className="text-2xl lg:text-4xl font-bold mb-4 bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
                Our Core Values
              </h2>
              <div className="w-20 lg:w-24 h-1 bg-gradient-to-r from-teal-500 to-emerald-500 mx-auto mb-4 rounded-full"></div>
              <p className="text-gray-600 max-w-3xl mx-auto">
                The principles that guide everything we do
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6">
              {values.map((value) => (
                <motion.div
                  key={value.id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: value.id * 0.1 }}
                  whileHover={{ scale: 1.1 }}
                  className="flex flex-col items-center text-center"
                >
                  <div className={`bg-gradient-to-r ${value.color} w-16 h-16 lg:w-20 lg:h-20 rounded-2xl flex items-center justify-center mb-4 shadow-lg`}>
                    <div className="text-white text-2xl lg:text-3xl">
                      {value.icon}
                    </div>
                  </div>
                  <h3 className="font-bold text-gray-800 text-sm lg:text-base mb-2">{value.title}</h3>
                  <p className="text-gray-600 text-xs lg:text-sm">{value.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.section>

          {/* Team & Story */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
            {/* Our Story */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 lg:p-8 border border-blue-200"
            >
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Our Journey</h3>
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Founded in 2020, Anusaya began as a vision to simplify healthcare access in India. We started with a small team of doctors, technologists, and healthcare enthusiasts who believed that quality medical care should be accessible to everyone.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Today, we've grown into a comprehensive platform serving thousands of patients across the country, constantly innovating to meet evolving healthcare needs.
                </p>
              </div>

              <div className="mt-6 bg-white p-6 rounded-xl shadow-sm">
                <div className="flex items-center">
                  <div className="bg-gradient-to-r from-teal-500 to-emerald-500 w-12 h-12 rounded-xl flex items-center justify-center mr-4">
                    <GiGrowth className="text-white text-2xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800">Continuous Growth</h4>
                    <p className="text-gray-600 text-sm">Expanding services and reach every day</p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Meet Our Team */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl shadow-xl p-6 lg:p-8 border border-gray-200"
            >
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Meet Our Experts</h3>
              <div className="space-y-6">
                <div className="flex items-center">
                  <div className="bg-gradient-to-r from-blue-500 to-cyan-500 w-16 h-16 rounded-2xl flex items-center justify-center mr-4">
                    <GiDoctorFace className="text-white text-2xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800">Medical Professionals</h4>
                    <p className="text-gray-600">Certified doctors and healthcare specialists</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="bg-gradient-to-r from-green-500 to-emerald-500 w-16 h-16 rounded-2xl flex items-center justify-center mr-4">
                    <FaBalanceScale className="text-white text-2xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800">Nutrition Experts</h4>
                    <p className="text-gray-600">Registered dietitians and nutritionists</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-16 h-16 rounded-2xl flex items-center justify-center mr-4">
                    <FaRocket className="text-white text-2xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800">Tech Innovators</h4>
                    <p className="text-gray-600">Technology team ensuring seamless experience</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* CTA Section */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-teal-600 via-emerald-500 to-teal-400 rounded-2xl lg:rounded-3xl p-6 lg:p-8 text-white shadow-2xl"
          >
            <div className="flex flex-col lg:flex-row items-center justify-between">
              <div className="mb-6 lg:mb-0 lg:mr-8">
                <h3 className="text-2xl lg:text-3xl font-bold mb-3">Ready to Transform Your Health Journey?</h3>
                <p className="text-white/90 mb-4">
                  Join thousands who have found better health through our platform
                </p>
                <div className="flex items-center">
                  <FaHandHoldingHeart className="text-2xl mr-3" />
                  <div>
                    <div className="font-bold">Start Your Health Journey Today</div>
                    <div className="text-sm opacity-80">Personalized care at your fingertips</div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <button className="bg-white text-teal-600 px-6 lg:px-8 py-3 lg:py-4 rounded-xl font-bold hover:shadow-2xl transition-all shadow-lg">
                  <FaPhoneAlt className="inline mr-3" />
                  Contact Us
                </button>
                <button className="bg-white/20 text-white px-6 lg:px-8 py-3 lg:py-4 rounded-xl font-bold hover:bg-white/30 transition-all border border-white/30">
                  <FaEnvelope className="inline mr-3" />
                  Email Support
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;